import { useEffect, useState } from "react";

export const DEFAULT_LINK_PRICE_IDR = 15_000;

export function formatIdr(amount: number) {
  return `Rp ${new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(amount)}`;
}

export function useLinkPricing() {
  const [amountIdr, setAmountIdr] = useState(DEFAULT_LINK_PRICE_IDR);

  useEffect(() => {
    let active = true;
    fetch("/api/pricing", { cache: "no-store" })
      .then((response) => {
        if (!response.ok) throw new Error("Pricing unavailable");
        return response.json() as Promise<{ amountIdr?: unknown }>;
      })
      .then((pricing) => {
        if (active && Number.isSafeInteger(pricing.amountIdr) && (pricing.amountIdr as number) > 0) {
          setAmountIdr(pricing.amountIdr as number);
        }
      })
      .catch(() => {
        // The server remains authoritative; the fallback only keeps copy readable.
      });
    return () => { active = false; };
  }, []);

  return amountIdr;
}
